import { UiStrategy } from "@/ui/UiStrategy";
import { useNewSession } from '@/hooks/use-new-session';
import { NewSessionClassicView } from "@/ui/v1/NewSessionClassicView";
import { NewSessionModernView } from "@/ui/v2/NewSessionModernView";
import { NewSessionNeonView } from "@/ui/v3/NewSessionNeonView";

export default function NewSession() {
  const { 
    settingsLoading, 
    isInitializingSession,
    ...props 
  } = useNewSession();

  if (settingsLoading || isInitializingSession) {
    return <div className="py-6 text-sm text-muted-foreground">Loading session...</div>;
  }

  return (
    <UiStrategy
      classic={<NewSessionClassicView {...props} />}
      modern={<NewSessionModernView {...props} />}
      neon={<NewSessionNeonView {...props} />}
    />
  );
}
